import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Produto } from '../../model/Produto';
import { Pedido } from '../../model/Pedido';
import { ItensPedido } from '../../model/ItensPedido';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MensagemService } from '../../service/mensagem.service';
import { PedidoService } from '../../service/pedido.service';
import { LoginService } from '../../service/login.service';
import { Helper } from 'src/app/shared/Helper';
import { debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { IntegracaoService } from 'src/app/service/integracao.service';
import { CacheService } from 'src/app/service/cache.service';

@Component({
  selector: 'app-pedido',
  templateUrl: './pedido.component.html',
  styleUrls: ['./pedido.component.css']
})
export class PedidoComponent implements OnInit {


  @ViewChild('txtProduto') txtProduto: ElementRef;
  @ViewChild('txtQuantidade') txtQuantidade: ElementRef;

  public Pedido: Pedido;
  private timer: number = 30000;

  produtoControl = new FormControl();
  quantidadeControl = new FormControl();
  public filteredOptions: any;
  public quantidadeEdicao;
  public gravando: boolean = false;
  public itemEdicao: any;
  public resultado: number = 0;
  public resultado2: number = 0;
  public pedidoCacheId;
  public dtUltimoAcesso: Date;
  public killPedidoWeb: boolean;
  public qtde1: number;
  public qtde2: number;
  public tot1: number;
  public tot2: number;

  constructor(
    private msg: MensagemService,
    private pedidoService: PedidoService,
    private loginService: LoginService,
    private router: Router,
    private integracaoService: IntegracaoService,
    private cacheService: CacheService) {
    this.Pedido = new Pedido();
  }

  public AddItemPedido() {
    if (this.produtoControl.value && this.produtoControl.value.descricao) {
      if (this.quantidadeControl.value) {
        var prod = this.produtoControl.value;
        var qtde = this.quantidadeControl.value;
        if (qtde <= 0) {
          this.msg.Aviso("Quantidade deve ser maior que zero!");
          return;
        }
        this.Pedido.AddItem(prod.produtoId, prod.codigo, prod.descricao, qtde, prod.preco, prod.empresa, prod.qtdePorCaixa);
        this.cacheService.GetDataCache().subscribe(dt => {
          if (dt.data && this.dtUltimoAcesso && (dt.data > this.dtUltimoAcesso)) {
            this.killPedidoWeb = true;
          }
          else {
            this.cacheService.AddItemCache(this.pedidoCacheId, prod.produtoId, qtde).subscribe(rt => {
              if (rt && rt.sucesso) {
                if (prod.empresa == '010101') {
                  this.qtde1 += Number(qtde);
                  this.tot1 += Number(Number(qtde) * Number(prod.preco));
                }
                if (prod.empresa == '020201') {
                  this.qtde2 += Number(qtde);
                  this.tot2 += Number(Number(qtde) * Number(prod.preco));
                }
              }
            })
          }
        });
        this.produtoControl.reset();
        this.quantidadeControl.reset();
        this.filteredOptions = new Array<Produto>();
        this.txtProduto.nativeElement.focus();
      }
      else {
        this.msg.Aviso("Quantidade deve ser informado!");
      }
    }
    else {
      this.msg.Aviso("Produto deve ser informado!");
    }
  }



  displayFn(produto?: any): string | undefined {
    return produto ? produto.descricao : undefined;
  }

  pad(num: number, size: number) {
    return Helper.pad(num, size);
  }

  OkResultado() {
    this.gravando = true;
    this.cacheService.IncluirCache().subscribe(rt => {
      this.pedidoCacheId = rt.pedidoCacheId;
      this.dtUltimoAcesso = rt.dtUltimoAcesso;
      //var that = this;
      //setTimeout(function () { that.validaCache(that); }, that.timer);
      this.resultado = 0;
      this.resultado2 = 0;
      this.qtde1 = 0;
      this.qtde2 = 0;
      this.tot1 = 0;
      this.tot2 = 0;
      this.gravando = false;
    });
  }

  ngOnInit() {
    this.qtde1 = 0;
    this.qtde2 = 0;
    this.tot1 = 0;
    this.tot2 = 0;
    var that = this;
    var possuiQuantidadeZerada: boolean = false;

    if (this.integracaoService.cachePlanilha) {
      var cp = this.integracaoService.cachePlanilha;

      cp.itens.forEach(it => {
        if (Number(it.quantidade) <= 0) {
          possuiQuantidadeZerada = true;
        }
      });

      if (possuiQuantidadeZerada) {
        this.msg.Aviso("A planilha importada possui itens com quantidade zerada. Verifique a planilha e importe novamente.");

      }
      else {

        cp.itens.forEach(it => {
          var qtde: number = Number(it.quantidade);
          this.Pedido.AddItem(it.produtoFK, it.produto.codigo, it.produto.descricao, it.quantidade, it.produto.preco, it.produto.empresa, it.produto.qtdePorCaixa);
          if (it.produto.empresa == '010101') {
            this.qtde1 += Number(qtde);
            this.tot1 += Number(Number(qtde) * Number(it.produto.preco));
          }
          if (it.produto.empresa == '020201') {
            this.qtde2 += Number(qtde);
            this.tot2 += Number(Number(qtde) * Number(it.produto.preco));
          }
        });
      }
      this.integracaoService.cachePlanilha = null;
    }
    else if (this.cacheService.Cache) {
      var c = this.cacheService.Cache;

      c.itens.forEach(it => {
        var qtde: number = Number(it.quantidade);
        this.Pedido.AddItem(it.produtoFK, it.produto.codigo, it.produto.descricao, it.quantidade, it.produto.preco, it.produto.empresa, it.produto.qtdePorCaixa);
        if (it.produto.empresa == '010101') {
          this.qtde1 += Number(qtde);
          this.tot1 += Number(Number(qtde) * Number(it.produto.preco));
        }
        if (it.produto.empresa == '020201') {
          this.qtde2 += Number(qtde);
          this.tot2 += Number(Number(qtde) * Number(it.produto.preco));
        }
      });
      this.pedidoCacheId = this.cacheService.Cache.pedidoCacheId;
      this.dtUltimoAcesso = this.cacheService.Cache.dtUltimoAcesso;
      setTimeout(function () { that.validaCache(that); }, that.timer);
      this.cacheService.Cache = null;
    }
    else {
      this.cacheService.IncluirCache().subscribe(rt => {
        if (rt && rt.sucesso) {
          this.pedidoCacheId = rt.pedidoCacheId;
          this.dtUltimoAcesso = rt.dtUltimoAcesso;
          setTimeout(function () { that.validaCache(that); }, that.timer);
        }
      })
    }


    setTimeout(function () { that.txtProduto.nativeElement.focus(); }, 1000);
    this.loginService.Refresh();

    try {

      this.produtoControl.valueChanges
        .pipe(
          debounceTime(400))
        .subscribe((value: string) => {
          this._filter(value);
        })
        ;
    }
    catch {

    }
  }

  public FinalizarPedidoWeb(that) {
    localStorage.removeItem("jwt");
    that.loginService.Logado = false;
    that.router.navigate(['/login']);
  }

  public validaCache(that: any) {
    if (that.router.url == '/pedido') {
      that.cacheService.GetDataCache().subscribe(dt => {
        if (dt.data) {
          if (that.dtUltimoAcesso && dt.data > that.dtUltimoAcesso) {
            that.killPedidoWeb = true;
          }
          else {
            setTimeout(function () { that.validaCache(that); }, that.timer);
          }
        }
        else {
          setTimeout(function () { that.validaCache(that); }, that.timer);
        }
      })
    }
  }

  public ProdutoKeyUp(event) {
    if (event.key === "Enter") {
      this.txtQuantidade.nativeElement.focus();
    }
  }
  public QuantidadeKeyUp(event) {
    if (event.key === "Enter") {
      this.AddItemPedido();
    }
  }

  public QuantidadeGridKeyUp(event) {
    if (event.key === "Enter") {
      this.ConfirmarItem(this.itemEdicao);
    }
  }

  public GoToHome() {
    this.router.navigate(['/']);
  }

  public Gravar() {
    if (this.Pedido.Itens.length) {
      this.Pedido.UsuarioFK = Helper.getUserIdToken();
      this.Pedido.VendedorFK = Helper.getVendedorToken();
      this.gravando = true;
      this.cacheService.GetDataCache().subscribe(dt => {
        if (dt.data && this.dtUltimoAcesso && (dt.data > this.dtUltimoAcesso)) {
          this.killPedidoWeb = true;
        }
        else {
          this.pedidoService.Gravar(this.Pedido).subscribe(p => {
            if (p.sucesso) {
              this.cacheService.FinalizarCache().subscribe(rt => {
                this.dtUltimoAcesso = null;
                this.pedidoCacheId = null;
                this.Pedido = new Pedido();
                if (p.nrPedido) {
                  this.resultado = p.nrPedido;
                }
                if (p.nrPedido2) {
                  this.resultado2 = p.nrPedido2;
                }
                this.msg.Aviso("Pedido gerado com sucesso!");
              })
            }
            this.gravando = false;
          })
        }
      });
    }
    else {
      this.msg.Aviso("Nenhum Produto adicionado!");
    }
  }

  public EditarItem(it) {
    this.quantidadeEdicao = it.quantidade;
    this.itemEdicao = it;
  }


  public ConfirmarItem(it) {
   if (this.quantidadeEdicao <= 0) {
      this.msg.Aviso("Quantidade deve ser maior que zero!");
      return;
    }

    if (it) {
      if (it.tipoProduto == '010101') {
        this.qtde1 -= Number(it.quantidade);
        this.tot1 -= Number(it.vrTotal);
      }
      if (it.tipoProduto == '020201') {
        this.qtde2 -= Number(it.quantidade);
        this.tot2 -= Number(it.vrTotal);
      }
    }
    it.quantidade = this.quantidadeEdicao;
    if (it) {
      if (it.tipoProduto == '010101') {
        this.qtde1 += Number(it.quantidade);
        this.tot1 += Number(it.vrTotal);
      }
      if (it.tipoProduto == '020201') {
        this.qtde2 += Number(it.quantidade);
        this.tot2 += Number(it.vrTotal);
      }
    }
    this.cacheService.GetDataCache().subscribe(dt => {
      if (dt.data && this.dtUltimoAcesso && (dt.data > this.dtUltimoAcesso)) {
        this.killPedidoWeb = true;
      }
      else {
        this.cacheService.UpdateItemCache(this.pedidoCacheId, it.produtoId, it.quantidade).subscribe(rt => {

        })
      }
    });
    this.quantidadeEdicao = 0;
    this.itemEdicao = null;
  }
  public Cancelar(it) {
    this.itemEdicao = null;
  }

  public ExcluirItem(it) {
    var that = this;
    this.msg.ConfirmDialog("Exclusão da item", 'Realmente deseja excluir o item "' + it.descricao + '?"', function (result) {
      if (result) {
        var i = -1;
        var index = -1;
        that.Pedido.Itens.forEach(item => {
          i = i + 1;
          if (item.codProduto == it.codProduto) {
            index = i;
          }
        });
        if (index > -1) {
          var rmItem = that.Pedido.Itens[index];
          that.cacheService.GetDataCache().subscribe(dt => {
            if (dt.data && that.dtUltimoAcesso && (dt.data > that.dtUltimoAcesso)) {
              that.killPedidoWeb = true;
            }
            else {
              that.cacheService.RemoveItemCache(that.pedidoCacheId, rmItem.produtoId).subscribe(rt => {
                if (rt && rt.sucesso) {

                }
              })
            }
          });
          var tmp = that.Pedido.Itens[index];
          if (tmp) {
            if (tmp.tipoProduto == '010101') {
              that.qtde1 -= Number(tmp.quantidade);
              that.tot1 -= Number(tmp.vrTotal);
            }
            if (tmp.tipoProduto == '020201') {
              that.qtde2 -= Number(tmp.quantidade);
              that.tot2 -= Number(tmp.vrTotal);
            }
          }
          that.Pedido.Itens.splice(index, 1);
        }
      }
    }
    );
  }

  private _filter(value: any): any {

    var filtro = "";
    if (value) {
      filtro = value.descricao ? value.descricao.toLowerCase() : value.toLowerCase();
    }
    if (filtro != "") {
      this.pedidoService.Filtrar(this.loginService.codTabela, filtro).subscribe(f => {
        this.filteredOptions = f;
      })
    }

  }

}
